import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setComponentField } from '../modules/component/actions';

/**
 * Ersetzt das frühere ComponentContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `component.xxx`/`component.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useComponentState() {
    const component = useSelector((state) => state.component);
    const dispatch = useDispatch();

    const setIsSelected = useCallback((value) => dispatch(setComponentField('isSelected', value)), [dispatch]);
    const setName = useCallback((value) => dispatch(setComponentField('name', value)), [dispatch]);
    const setCode = useCallback((value) => dispatch(setComponentField('code', value)), [dispatch]);
    const setDesc = useCallback((value) => dispatch(setComponentField('desc', value)), [dispatch]);

    return {
        isSelected: component.isSelected, setIsSelected,
        name: component.name, setName,
        code: component.code, setCode,
        desc: component.desc, setDesc,
    };
}
